import { TableCell, TableHead, TableRow } from '@mui/material';
import React, { memo } from 'react';

function TasksTableHead() {
  return (
    <TableHead>
      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
        <TableCell sx={{ width: { xs: '200px', sm: '20%' }, minWidth: '150px', fontWeight: 600 }}>
          Task Name
        </TableCell>
        <TableCell sx={{ width: { xs: '120px', sm: '12%' }, minWidth: '100px', fontWeight: 600 }}>
          Total Hours
        </TableCell>
        <TableCell sx={{ width: { xs: '100px', sm: '10%' }, minWidth: '80px', fontWeight: 600 }}>
          RCD
        </TableCell>
        <TableCell sx={{ width: { xs: '120px', sm: '12%' }, minWidth: '100px', fontWeight: 600 }}>
          Due Date
        </TableCell>
        <TableCell sx={{ width: { xs: '120px', sm: '12%' }, minWidth: '100px', fontWeight: 600 }}>
          Amount
        </TableCell>
        <TableCell sx={{ width: { xs: '120px', sm: '12%' }, minWidth: '100px', fontWeight: 600 }}>
          Status
        </TableCell>
        <TableCell
          sx={{ width: { xs: '150px', sm: '17%' }, minWidth: '120px', pr: 3.5, fontWeight: 600 }}
          align="right"
        >
          Actions
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

export default memo(TasksTableHead);
